import React, { SVGProps } from 'react'
export const FourthDefaultLeftSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M5.884 4.877C2.958 7.293.785 11.74.98 19.949c.155 6.526 2.338 10.34 5.202 12.496C9.066 34.617 12.5 35 16 35v1c-3.5.031-7.265-.417-10.399-2.777C2.446 30.847.173 26.72.012 19.973-.187 11.59 2.032 6.799 5.27 4.126 8.485 1.47 12.624 1 16 1v1c-3.32 0-7.17.443-10.116 2.877Z"
      clipRule="evenodd"
    />
  </svg>
)
